import { apiSlice } from '../api/apiSlice';

import {
  CreateTicketParams,
  CreateTicketResponse,
  TicketParams,
  TicketResponse,
  TicketsParams,
  TicketsResponse,
} from './ticketingApiSliceTypes';

const esimApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createTicket: builder.mutation<CreateTicketResponse, CreateTicketParams>({
      query: (params) => ({
        url: '/tickets/create',
        method: 'POST',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
        body: {
          subject: params.subject,
          message: params.message,
          email: params.email,
        },
      }),
    }),

    getTickets: builder.query<TicketsResponse, TicketsParams>({
      query: (params) => ({
        url: '/tickets',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),

    getTicket: builder.query<TicketResponse, TicketParams>({
      query: (params) => {
        return {
          url: `/tickets/${params.id}`,
          method: 'GET',
          headers: {
            'Accept-Language': params.acceptLanguage ?? 'en',
          },
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateTicketMutation,
  useGetTicketQuery,
  useGetTicketsQuery,
  useLazyGetTicketQuery,
  useLazyGetTicketsQuery,
} = esimApiSlice;
